import {on} from "../jsbase/events";
var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {
    },

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {

            /*<ul id="tree-contextmenu" class="tree-contextmenu dropdown-menu" role="menu">*}
                 <li class="position-open"><a class="dropdown-item" href="#position-open"><i class="fa fa-fw bi-plus"></i> öffnen</a></li>*}
                 <li class="add-position"><a class="dropdown-item" href="#add-position"><i class="fa fa-fw bi-plus-circle-fill"></i> Position hinzufügen</a></li>*}
                 <li class="delete-position"><a class="dropdown-item" href="#delete-position"><i class="fa fa-fw bi-trash text-danger"></i> Position löschen</a></li>*}
              </ul>*/
            fetchElementData: function($rowElem) {
                var rowId = $rowElem.attr('data-id');
                var showAddPosition = ($rowElem.is('.node,.leaf[data-childs="0"]')
                        && !$rowElem.is('[data-depth="1"],[data-depth="2"]'))
                        || $rowElem.is('tr[data-aid="6"],tr[data-aid="7"],tr[data-aid="8"],tr.own-pos[data-childs="0"]');
                return {
                    id: rowId,
                    $el: $rowElem,
                    isNode: $rowElem.is('.node'),
                    isLeaf: $rowElem.is('.leaf'),
                    isCompanyPosition: $rowElem.is('.own-pos'),
                    level: $rowElem.attr('data-depth'),
                    showAddPosition: showAddPosition,
                };
            },
            actions: {
                extendPosition: {
                    name: 'öffnen',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-plus',
                    onClick: this.extendPosition,
                },
                addPosition: {
                    name: 'Position hinzufügen',
                    classNames: 'dropdown-item border-top',
                    iconClass: 'bi-plus-circle-fill',
                    onClick: this.addPosition,
                    isShown: function(row) {
                        return row.showAddPosition;
                    }
                },
                copyPosition: {
                    name: 'Position duplizieren',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-clipboard',
                    onClick: this.copyPosition,
                    isShown: function(row) {
                        return row.isLeaf;
                    }
                },
                deletePosition: {
                    name: 'Position löschen',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-trash text-danger',
                    onClick: this.deletePosition,
                    isShown: function(row) {
                        return row.isCompanyPosition;
                    }
                },
            },
        });
    },

    events: [{
        name: 'calculation.part-loaded',
        el() {
            return document;
        },
        handler(ev) {
            $.each(ev.detail.container, (i, cel) => {
                if (cel) {
                    cel.querySelectorAll('.btn-context-click').forEach((el) => {
                        on(el, 'click', (cev) => {
                            cev.preventDefault();
                            cev.stopPropagation();
                            var rowEl = $(cev.target).closest(this.selector);
                            this.menu.open(rowEl, cev);
                        });
                    });
                }
            });
        },
    }],

    methods: {
        extendPosition(row) {
            if (row.id) {
                console.log('extendPosition', row);
                if (row.$el.is('.node')) {
                    project.openSubPositionsPart(row.$el);
                } else if (row.$el.is('.leaf')) {
                    row.$el.addClass('slidein-active');
                    slidein.openUrl('/Project/PositionPriceDetail/' + row.id, function (element) {
                        project.initPositionDetails(element);
                    });
                }
            }
        },
        addPosition(row) {
            if (row.id) {
                var templateId = row.$el.closest('[data-mypos-templateId]').attr('data-mypos-templateId');
                var parentId = row.$el.attr('data-posid');
                slidein.openUrl('/Project/CreatePositionSlideIn?templateVersionId='+templateId+'&parentNumberId='+parentId);
            }
        },
        copyPosition(row) {
            if (row.id) {
                project.copyPosition(null, row.$el, true);
            }
        },
        deletePosition(row) {
            if (row.id) {
                project.deletePosition(null, row.$el);
            }
        },
    },

}
